import { render, staticRenderFns } from "./FieldPermission.vue?vue&type=template&id=0ed953fb&scoped=true"
import script from "./FieldPermission.vue?vue&type=script&lang=js"
export * from "./FieldPermission.vue?vue&type=script&lang=js"
import style0 from "./FieldPermission.vue?vue&type=style&index=0&id=0ed953fb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed953fb",
  null
  
)

export default component.exports